<template>
  <div class="portlet_wrapper">
    <div class="cnt_block">
      <div id="create_enter_area"></div>
      <div class="btn_area">
        <button class="btn--pill pill blue" @click.prevent="submitData">確定</button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import blueprint from '~components/common/forms/blueprints/TeacherAccountSettingsForm.js'
import { enter_area } from '~components/common/enter_area.js'
import '~style/components/enter_area.css'
export default {
  name: 'TeacherAccountSettings',
  components: {},
  computed: {
    ...mapGetters('pages/teachers', [
      'currentTeacherGetter'
    ]),
    ...mapGetters('pages/students', [
      'departmentsGetter',
    ]),
  },
  watch: {
  },
  data () {
    return {
      enterArea: null,
    };
  },
  async mounted () {
    this.togglePageLoader(true);
    let el = $('#create_enter_area')[0];
    this.enterArea = new enter_area(el, blueprint);

    await this.getDepartments();
    let dept_options = this.departmentsGetter.map(val => val.department_name);
    let dept_values = this.departmentsGetter.map(val => val.department_id);
    this.enterArea
    .set_enter_block_options('department_of_id', dept_options, dept_values);

    await this.getTeacherByToken();
    this.enterArea.set_form_data({
      department_of_id: this.currentTeacherGetter.teacher_department_id - 1,
      email: this.currentTeacherGetter.teacher_email,
      name: this.currentTeacherGetter.teacher_name,
      tel: this.currentTeacherGetter.teacher_phone_number,
    });
    this.togglePageLoader(false);
  },
  methods: {
    ...mapActions('pages/teachers', [
      'updateTeacherProfile',
      'getTeacherByToken',
    ]),
    ...mapActions('layouts', [
      'newToast',
      'togglePageLoader',
    ]),
    ...mapActions('pages/students', [
      'getDepartments',
    ]),
    async submitData () {
      if(!this.enterArea) return;
      if(!this.enterArea.valid()) {
        this.newToast({
          variant: 'warning',
          message: '請確認所有欄位是否都有填寫完整'
        });
        return;
      }
      this.togglePageLoader(true);
      let form_data = this.enterArea.get_form_data();
      await this.updateTeacherProfile(form_data);
      this.togglePageLoader(false);
    },
  }
}
</script>

<style lang="scss" scoped>
  .teacher_area .cnt_block { padding: 32px 38px 48px; }
  .btn_area {
    margin-top: 18px;
    text-align: right;

    @media (max-width: 768px) { text-align: center; margin-top: 21px; }
  }
</style>
